import React, { useEffect, useState } from 'react';
import CallOut from '../../Common/CallOut';
import ajaxReport from '../../../util/remote/ajaxReport';
import Notification from '../../Common/Notification';
import GeneralCommentWriter from './Elements/GeneralCommentWriter';
import ListItem from '../../Common/List/ListItem';
import TextInput from '../../Common/TextInput';
import { useConfig } from '../../../DataStore/ConfigContext';
import { useReport } from '../../../DataStore/ReportContext';


const ReportComments = ({reportInfo}) => {
  const [notify, setNotify] = useState(null);
  const [reportComments, setReportComments] = useState(false);
  const [activeComment, setActiveComment] = useState(false);
  const {getReportCommentConfig, reportCommentListing} = useConfig();
  const [commentId, setCommentId] = useState("");
  const [loading, setLoading] = useState(false);
  const {setRemoveComment, setCommentWriter} = useReport();


  useEffect(() => {
    getReportCommentConfig();
    }, []);

  useEffect(() => {
    if(reportInfo && reportInfo.id){
        getReportComments();
    }
  }
  , [reportInfo]);

  const getReportComments=async()=>{
    const server_response = await ajaxReport.getReportComments(reportInfo.id);
    if(server_response.status==="OK")
    {
        setReportComments(server_response.details)
    }else{
        setReportComments("404")
        setNotify(<Notification type="danger" message={server_response.message}/>)
    }
  }

   const deleteCommentField=async(fieldId)=>{

        const server_response = await ajaxReport.deleteReportCommentField(fieldId);
        if(server_response.status==="OK"){
            getReportComments();
            setNotify(<Notification type="success" message={server_response.message}/>)
        }else{
            setNotify(<Notification type="danger" message={server_response.message}/>)
        }

    }

    const onChangeComment=(option)=>setCommentId(option.value)


    const  handleChangeInitials=(comment)=>{

    }

    const handleRemoveComment=(comment)=>{
        setRemoveComment({show: true, comment, callback: getReportComments});
    }

    const handleEdit = (comment)=>{
        setCommentWriter({show: true, comment, callback: getReportComments});
    }

    const saveReportComment=async()=>{
        if(commentId>0 && reportInfo.id){ 
           setLoading(true);  
           const server_response = await ajaxReport.addReportComment(reportInfo.id, commentId);
           setLoading(false);
           if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            getReportComments();
           }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)
           }

        }else{
            
            setNotify(<Notification type='danger' message={"Select comment and try again"}/>)
        
        }
    }

    const RenderItem=(propItem)=>{
        const item = propItem.item;
        if(item.comment.scope.id*1===2) //general comment
        {
            if(activeComment && item.id===activeComment.id)
            {   
                return <GeneralCommentWriter field={item} onConfirm={getReportComments}/>

            }else{

                return <ListItem 
                title={item.comment.title}
                subtitle={item.value || "No comment set"}
                listIcon="fa fa-comment"
                handleDelete={()=>handleRemoveComment(item)}
                handleEdit={()=>handleEdit(item)}
                />
            }
            
        }else{ //specific comment
            return <ListItem 
            title={item.comment.title}
            delete={()=>{deleteCommentField(item.id)}}
            listIcon="fa fa-comment txt-primary"
            subtitle={item.staff?item.staff.full_name : "No initials set"}
            handleDelete={()=>handleRemoveComment(item)}
            handleEdit={()=>handleEdit(item)}

        />
        }
    }


      const RenderComment=()=>{

        const optionsListing=[];

        if(Array.isArray(reportCommentListing))
        {
            reportCommentListing.map((item, key)=>
            optionsListing.push({label:item.title, value:item.id})
            )
         }



      
            return(
                <TextInput
                    label="Set Report Comment"
                    leftIcon={true}
                    type="select" 
                    placeholder="Select comment...." 
                    options={optionsListing}
                    onChange={onChangeComment}
                    leftComponent={<i className="fa fa-check txt-primary" onClick={saveReportComment}/>}
                    wrap
                    loading={loading}
                />
            )

          
    }


 
  return (
    <div className="card-body">
      <CallOut
        title="Report Comments"
        description={`Add, remove and update report comments for ${reportInfo.title}`}
      />
      {notify}

        {Array.isArray(reportComments) && reportComments.map((item, key)=>
            <RenderItem item={item} key={key}/>
        )}

        <div className='mt-3'></div>

          {RenderComment()}
                 
    </div>
             
  );
};

export default ReportComments;
